/* eslint-disable react/prop-types */
import { Card, CardHeader, Icon, useMediaQuery, useTheme } from "@mui/material";
import { useNavigate } from "react-router-dom";
import DashboardLayout from "~/examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "~/examples/Navbars/DashboardNavbar";
import MDBox from "./MDBox";
import MDButton from "./MDButton";

const GenericFormContainer = ({
  cardHeaderTitle,
  careSubHeaderTitle = "",
  cardActionText = "Back",
  navigateTo,
  startIcon = "arrow_back",
  children,
  ...otherProps
}) => {
  const navigate = useNavigate();
  const theme = useTheme();
  const matchesXs = useMediaQuery(theme.breakpoints.down("md"));
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Card>
        <MDBox {...otherProps}>
          <CardHeader
            action={
              <MDButton
                variant="contained"
                color="success"
                aria-label="navigation"
                size={matchesXs ? "small" : "large"}
                startIcon={<Icon>{startIcon}</Icon>}
                onClick={() => navigate(navigateTo, { replace: true })}
              >
                {cardActionText}
              </MDButton>
            }
            title={cardHeaderTitle}
            subheader={careSubHeaderTitle}
          />
          {/* <MDTypography variant="h5">Create Plant</MDTypography> */}
        </MDBox>
        {children}
      </Card>
    </DashboardLayout>
  );
};

export default GenericFormContainer;
